export default {
  setConfigTests (state, result) {
    state.configTests = result
  }
}
